// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"CollegePage_toolbar__3Pjzk","buttons":"CollegePage_buttons__jI-YT","save":"CollegePage_save__1lorL","delete":"CollegePage_delete__33iu7","back":"CollegePage_back__5JNwV"};